import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LocalFileReaderForm from '../forms/local-file-reader-form';
import { localFileReaderValidationSchema } from '../schema/localFileReader.js';

export default function LocalFileReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Local File Reader Node Details',
        altText: 'Local File Reader Node',
        defaultLabel: 'Local File Reader Node',
      }}
    >
      <CommonNode
        FormComponent={LocalFileReaderForm}
        schemaResolver={localFileReaderValidationSchema}
      />
    </NodeProvider>
  );
}
